"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA = void 0;

var _react = _interopRequireDefault(require("react"));

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CTA = function CTA(_ref) {
  var text = _ref.text,
      buttonText = _ref.buttonText,
      url = _ref.url;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.Text, null, text), _react.default.createElement(_styles.Button, {
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, buttonText)));
};

exports.CTA = CTA;